export enum BankAccountType {
  CURRENT = 1,
  SAVINGS = 2,
  PAYMENTS = 3,
  IP = 4,
}

export const AccountTypeArray = [
  {
    id: BankAccountType.CURRENT,
    name: 'Corrente',
  },
  {
    id: BankAccountType.SAVINGS,
    name: 'Poupança',
  },
];

export const getAccountType = (id: number) => {
  return AccountTypeArray.find((o) => o.id === Number(id))?.name;
};
